module.exports = __webpack_public_path__ + "media/svg/student-loan-hero-e0695a15.svg";